import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';
import {
  HttpClient,
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpResponse,
  HttpErrorResponse
} from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { AppLoadingService } from '../common/loading.service';
import { of } from 'rxjs/observable/of';

@Injectable()
export class CsrService {
  hostUrl: any = environment.API_BASE_URL;
  portalHostUrl = environment.PORTAL_BASE_URL;
  customerUrl: any = environment.CUSTOMER_BASE_URL;
  public token: string;
  // TODO create one json variable and store urls in it.
  urlToGetAccounts: any = this.hostUrl + 'api/getAccountById';
  urlToGetScript: any = this.hostUrl + 'api/getScripts';
  urlToSaveNotes: any = this.hostUrl + 'api/addNotes';
  urlToGetCalls: any = this.hostUrl + 'api/getCalls';
  urlToGetChats: any = this.hostUrl + 'api/getChats';
  urlToGetSavings: string = this.hostUrl + 'api/getSavingSummary';
  urlToGetCustomerSavings: string = this.hostUrl + 'api/getSavingByCustAccount';
  urlToGetAccountSavings: string = this.hostUrl + 'api/getSavingByAccount';
  urlToGetAccountSaving: string = this.hostUrl + 'api/getSaving';
  urlToGetRefundHistory: string = this.hostUrl + 'api/customerRefundHistory';
  urlToGetCharges: string = this.hostUrl + 'api/paymentHistory';
  urlForRatings: string = this.hostUrl + 'api/createRating';
  urlForReferral: string = this.hostUrl + 'api/createReferral';
  urlToVerifyStripe: string = this.hostUrl + 'api/verifyStripeCard';
  urlToStorePdf: string = this.hostUrl + 'api/pdfUpload';
  urlForChargeCustomer: string = this.hostUrl + 'api/chargeCustomer';
  urlForRefundCustomer: string = this.hostUrl + 'api/refundPayment';
  urlToFixOutOfSync: string = this.hostUrl + 'api/validateFixClickupCSRStatus';
  urlToFetchAccounts: string = this.hostUrl + 'api/getAccounts';
  urlToGetCSRStats: string = this.hostUrl + 'api/getCSRStats';
  urlToQueueRule: string = this.hostUrl + 'api/queueRule';
  urlToInitiateRefundRequest: string = this.hostUrl + 'api/queueRule';
  urlToGetCustomerStageMap: string = this.hostUrl + 'api/getCustomerStageMap';
  urlToGetRootConfig: string = this.hostUrl + 'api/getConfigsForFrontend';
  urlToGetMarketingStats: string = this.hostUrl + 'api/getMarketingStats';
  urlToGetMarketing12HourStats: string = this.hostUrl + 'api/getMarketing24HoursStats';
  urlToUpdateCustomerPriorityConfig: string = this.hostUrl + 'api/updateCustomerPriority';
  getNegotiators: string = this.hostUrl + 'api/getAvailableNegotiators';
  urlToPhoneLookup: string = this.hostUrl + 'api/getProviderNameAndId';
  urlToAssignEmployee: string = this.hostUrl + 'api/assignEmployee';
  urlToGetAccountsScraperData: string = this.hostUrl + 'api/getAccountsScraperData';
  urlToAttributeCustomer: string = this.customerUrl + 'customers/attributeCustomer';
  urlToGetCustomerAttributions: string = this.customerUrl + 'customers/customerAttributions';
  urlToSendBatchText: string = this.hostUrl + 'api/bulkSendTextTemplate';
  urlToGetMeatPrediction: string = this.portalHostUrl + 'savings/getMeatPrediction';
  urlToGetPlans: string = this.customerUrl + 'accounts/getPlans';
  // for caching
  csrStats: any;
  rootConfig: any;
  availableNegotiators: any;

  constructor(private _http: HttpClient) {}

  saveNotes(notes: any): Observable<any> {
    return this._http.post(this.urlToSaveNotes, notes).map((res: Response) => res);
  }

  fetchAccounts(user_id: string): Observable<any> {
    return this._http.get(this.urlToGetAccounts + '/' + user_id).map((res: Response) => res);
  }

  fetchCalls(phone: string): Observable<any> {
    return this._http.post(this.urlToGetCalls, { phone: phone }).map((res: Response) => res);
  }

  fetchScript(user_id: string): Observable<any> {
    return this._http.post(this.urlToGetScript, { cust_id: user_id }).map((res: Response) => res);
  }

  fetchSavingsSummary(user_id: string): Observable<any> {
    return this._http
      .post(this.urlToGetSavings, { customer_id: user_id })
      .map((res: Response) => res);
  }
  fetchChargesSummary(user_id: string): Observable<any> {
    return this._http.post(this.urlToGetCharges, { cust_id: user_id }).map((res: Response) => res);
  }

  uploadPDF(data: any): Observable<any> {
    return this._http.post(this.urlToStorePdf, data).map((res: Response) => res);
  }
  createReferral(data: any): Observable<any> {
    return this._http.post(this.urlForReferral, data).map((res: Response) => res);
  }
  ratings(data: any): Observable<any> {
    return this._http.post(this.urlForRatings, data).map((res: Response) => res);
  }
  verifyStripeCard(data: any): Observable<any> {
    return this._http.post(this.urlToVerifyStripe, data).map((res: Response) => res);
  }
  chargeCustomer(data: any): Observable<any> {
    return this._http.post(this.urlForChargeCustomer, data).map((res: Response) => res);
  }
  refundCustomer(data: any): Observable<any> {
    return this._http.post(this.urlForRefundCustomer, data).map((res: Response) => res);
  }
  fixOutOfSyncIssues(customer_id: string): Observable<any> {
    return this._http
      .post(this.urlToFixOutOfSync, { customer_id: customer_id })
      .map((res: Response) => res);
  }

  fetchAccountFilesAndCreds(data: any): Observable<any> {
    return this._http.post(this.urlToFetchAccounts, data).map((res: Response) => res);
  }
  getCSRStats(data: any): Observable<any> {
    const API_RESPONSE = JSON.parse(localStorage.getItem('API_RESPONSE_getCSRStats'));
    if (API_RESPONSE) {
      console.log('Cache Hit - getCSRStats');
      return of(API_RESPONSE); // return cached values
    }

    return this._http.post(this.urlToGetCSRStats, data).map((res: Response) => {
      this.csrStats = res;
      localStorage.setItem('API_RESPONSE_getCSRStats', JSON.stringify(res));
      return res;
    });
  }
  fetchCustomerSavingsSummary(user_id: string): Observable<any> {
    return this._http
      .post(this.urlToGetCustomerSavings, { customer_id: user_id })
      .map((res: Response) => res);
  }
  fetchAccountSavingsSummary(user_id: string): Observable<any> {
    return this._http
      .post(this.urlToGetAccountSavings, { account_id: user_id })
      .map((res: Response) => res);
  }
  fetchAccountSaving(saving_id: string): Observable<any> {
    return this._http
      .post(this.urlToGetAccountSaving, { saving_id: saving_id })
      .map((res: Response) => res);
  }
  fetchCustomerRefundHistory(user_id: string): Observable<any> {
    return this._http
      .post(this.urlToGetRefundHistory, { customer_id: user_id })
      .map((res: Response) => res);
  }
  getCustomerStageMap(): Observable<any> {
    return this._http.get(this.urlToGetCustomerStageMap).map((res: Response) => res);
  }
  queueRule(data): Observable<any> {
    return this._http.post(this.urlToQueueRule, data).map((res: Response) => res);
  }
  marketingStats(data): Observable<any> {
    return this._http.post(this.urlToGetMarketingStats, data).map((res: Response) => res);
  }
  marketing12HourStats(data): Observable<any> {
    return this._http.post(this.urlToGetMarketing12HourStats, data).map((res: Response) => res);
  }
  getRootConfig(): Observable<any> {
    const API_RESPONSE = JSON.parse(localStorage.getItem('API_RESPONSE_getRootConfig'));
    if (API_RESPONSE) {
      console.log('Cache Hit - getRootConfig');
      return of(API_RESPONSE); // return cached values
    }
    return this._http.get(this.urlToGetRootConfig).map((res: Response) => {
      this.rootConfig = res;
      localStorage.setItem('API_RESPONSE_getRootConfig', JSON.stringify(res));
      return res;
    });
  }
  getAvailableNegotiators(data): Observable<any> {
    const API_RESPONSE = JSON.parse(localStorage.getItem('API_RESPONSE_getAvailableNegotiators'));
    if (API_RESPONSE) {
      console.log('Cache Hit - getAvailableNegotiators');
      return of(API_RESPONSE); // return cached values
    }
    return this._http.post(this.getNegotiators, data).map((res: Response) => {
      this.availableNegotiators = res;
      localStorage.setItem('API_RESPONSE_getAvailableNegotiators', JSON.stringify(res));
      return res;
    });
  }
  updateCustomerPriorityConfig(data): Observable<any> {
    return this._http
      .post(this.urlToUpdateCustomerPriorityConfig, data)
      .map((res: Response) => res);
  }
  phoneLookup(data): Observable<any> {
    return this._http.post(this.urlToPhoneLookup, data).map((res: Response) => res);
  }

  assignEmployee(data): Observable<any> {
    return this._http.post(this.urlToAssignEmployee, data).map((res: Response) => res);
  }
  getAccountsScraperData(data): Observable<any> {
    return this._http.post(this.urlToGetAccountsScraperData, data).map((res: Response) => res);
  }
  attributeCustomer(data): Observable<any> {
    return this._http.post(this.urlToAttributeCustomer, data).map((res: Response) => res);
  }
  getCustomerAttributions(data): Observable<any> {
    return this._http.post(this.urlToGetCustomerAttributions, data).map((res: Response) => res);
  }

  sendBatchText(data): Observable<any> {
    return this._http.post(this.urlToSendBatchText, data).map((res: Response) => res);
  }

  getMeatPrediction(data): Observable<any> {
    return this._http.post(this.urlToGetMeatPrediction, data).map((res: Response) => res);
  }

  getPlans(data): Observable<any> {
    return this._http.get(this.urlToGetPlans + `/${data.providerId}`).map((res: Response) => res);
  }
}



// WEBPACK FOOTER //
// ./src/app/_services/main/csr.service.ts